import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();
  const { pathname, search, hash, key } = location;

  useEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => {
      window.history.scrollRestoration = previous;
    };
  }, []);

  useLayoutEffect(() => {
    try { sessionStorage.removeItem("pp-coin-restore-pending"); } catch {}

    const resetToTop = () => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    if (hash) {
      const id = hash.replace("#", "");
      resetToTop();
      const revealTarget = () => document.getElementById(id)?.scrollIntoView({ behavior: "auto", block: "start" });
      const frame = window.requestAnimationFrame(revealTarget);
      const retry = window.setTimeout(revealTarget, 120);
      return () => {
        window.cancelAnimationFrame(frame);
        window.clearTimeout(retry);
      };
    }

    resetToTop();
    const frame = window.requestAnimationFrame(resetToTop);
    const retry = window.setTimeout(resetToTop, 80);
    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(retry);
    };
  }, [pathname, search, hash, key]);

  return null;
};

export default ScrollToTop;
